import { CallOutlined, EmailOutlined, MessageOutlined, NotesRounded, WhatsApp } from '@mui/icons-material';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { CircularProgress, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useAppSelector } from '../../../../store/hooks';
import { crmCommunicationHistroyList, CRMKeys } from '../services/apiCalls';
var ComIcons = {
    Email: /*#__PURE__*/ React.createElement(EmailOutlined, {
        fontSize: "small",
        color: "inherit"
    }),
    SMS: /*#__PURE__*/ React.createElement(MessageOutlined, {
        fontSize: "small",
        color: "inherit"
    }),
    WhatsApp: /*#__PURE__*/ React.createElement(WhatsApp, {
        fontSize: "small",
        color: "inherit"
    }),
    Call: /*#__PURE__*/ React.createElement(CallOutlined, {
        fontSize: "small",
        color: "inherit"
    }),
    Notes: /*#__PURE__*/ React.createElement(NotesRounded, {
        fontSize: "small",
        color: "inherit"
    })
};
var IconColors = {
    Email: 'error',
    SMS: 'success',
    WhatsApp: 'success',
    Call: 'info',
    Notes: 'info'
};
export default function CommunicationTimeline(props) {
    var _crud$CRMKeys$communi;
    var value = props.value;
    var crud = useAppSelector(function (state) { return state.crud; });
    var list = (_crud$CRMKeys$communi = crud[CRMKeys.communicationHistory]) === null || _crud$CRMKeys$communi === void 0 ? void 0 : _crud$CRMKeys$communi.data;
    useEffect(function () {
        if (value !== null && value !== void 0 && value.id)
            crmCommunicationHistroyList({
                request: {
                    CustomerId: value === null || value === void 0 ? void 0 : value.id
                },
                key: CRMKeys.communicationHistory
            });
    }, [value === null || value === void 0 ? void 0 : value.id]);
    return /*#__PURE__*/ React.createElement(Stack, {
        p: 2,
        minHeight: 150,
        minWidth: 400,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg",
        fontWeight: "strong"
    }, "Communication Timeline"), crud["isLoading".concat(CRMKeys.communicationHistory)] !== 'loading' ? /*#__PURE__*/ React.createElement(Timeline, {
        position: "alternate",
        sx: {
            my: 4
        }
    }, list === null || list === void 0 ? void 0 : list.map(function (it) { /*#__PURE__*/ return React.createElement(TimelineItem, null, /*#__PURE__*/ React.createElement(TimelineOppositeContent, {
        sx: {
            m: 'auto 0'
        },
        align: "right",
        fontSize: "sm",
        color: "text.secondary"
    }, dayjs(it === null || it === void 0 ? void 0 : it.CommunicationDate).format('DD MMM, YYYY')), /*#__PURE__*/ React.createElement(TimelineSeparator, null, /*#__PURE__*/ React.createElement(TimelineConnector, null), /*#__PURE__*/ React.createElement(TimelineDot, {
        color: IconColors[it === null || it === void 0 ? void 0 : it.ChannelType],
        sx: {
            color: 'white'
        }
    }, /* icon */ ComIcons[it === null || it === void 0 ? void 0 : it.ChannelType]), /*#__PURE__*/ React.createElement(TimelineConnector, null)), /*#__PURE__*/ React.createElement(TimelineContent, {
        sx: {
            p: 2,
            margin: 'auto 0'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm"
    }, it === null || it === void 0 ? void 0 : it.MessageText), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "xs",
        color: "text.tertiary"
    }, it === null || it === void 0 ? void 0 : it.ResponseStatus))); })) : /*#__PURE__*/ React.createElement(CircularProgress, null));
}
